import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetDocumentResponseBody } from '../DocumentsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseDocumentQueryValues = {
  appId: string;
  documentId: string;
};

export const documentQueryKeyFactory: IQueryKeyFactory<
  IUseDocumentQueryValues
> = (values) =>
  values && (['document', values.appId, values.documentId] as const);

export const useDocumentQuery = (
  values?: IUseDocumentQueryValues,
  options?: UseQueryOptions<IApiGetDocumentResponseBody, ApiError>,
): UseQueryResult<IApiGetDocumentResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: documentQueryKeyFactory(values),
    queryFn: values
      ? () => api.documents.get(values.appId, values.documentId)
      : undefined,
    enabled: !!values,
    ...options,
  });
};
